import { SystemAlertSearchRequestQuery } from '@lio/api-types';

export const alertsQueryKeys = {
  all: ['alerts'] as const,
  alert: (id: string) => [...alertsQueryKeys.all, id] as const,
  alertHistory: () => [...alertsQueryKeys.all, 'alertHistory'] as const,
  searchAlerts: () => [...alertsQueryKeys.all] as const,
  searchWithParams: (params?: SystemAlertSearchRequestQuery) => [...alertsQueryKeys.searchAlerts(), params] as const,
};
